import React from 'react';
import ReactDOM from 'react-dom';
import DiscountPage from "./discountPage";

declare global {
  interface Window {
    TildaPlugin?: {
      phone_classes?: string;
      cart_classes?: string[];
    };
  }
}

let added: boolean = false;


// Запускаем сразу при загрузке DOM
document.addEventListener('DOMContentLoaded', function () {
  // Даем время Тильде инициализировать корзину
  // Корзины не всех клиентов успевают инициализироваться, пока уберем
  // setTimeout(initASGK, 250);

  // Дублирующая проверка через 1 секунду
  setTimeout(addASGKBlockFromButton, 1000);
});

// Универсальная функция ожидания и навешивания обработчика
function waitAndAddClickListener(selector: string, callback: () => void, options = {
  interval: 500,
  timeout: 10000
}): void {
  const start: number = Date.now();

  const tryAdd: () => void = (): void => {
    const elements: NodeListOf<Element> = document.querySelectorAll(selector);
    if (elements.length > 0) {
      elements.forEach((el: Element): void => el.addEventListener('click', callback));
      clearInterval(intervalId);
    } else if (Date.now() - start > options.timeout) {
      clearInterval(intervalId); // завершить попытки после таймаута
    }
  };

  tryAdd();
  const intervalId = setInterval(tryAdd, options.interval);
}

// Обработка динамических классов из TildaPlugin
const cartClasses: string[] = window?.TildaPlugin?.cart_classes?.map((cls: string): string => '.' + cls.replaceAll(' ', '.')) || [];
cartClasses.forEach((selector: string): void => {
  waitAndAddClickListener(selector, addASGKBlockFromButton);
});

// Все нужные селекторы
const staticSelectors: string[] = [
  '.t706__carticon',
  '.t706__sidebar-bottom',
  '.t706__cartpage-open-form',
  '.t396__elem.tn-elem.mycart',
  '.t396__elem.tn-elem.cartcopy_elem',
  '[href*="basket"]',
  '[href*="#order"]',
];

// Навешиваем обработчики для известных классов
staticSelectors.forEach((selector: string): void => {
  waitAndAddClickListener(selector, addASGKBlockFromButton);
});

// под leru-collection обработка
waitAndAddClickListener('[href*="tproduct"]', (): void => {
  setTimeout(() => {
    waitAndAddClickListener('[href*="#order"]', addASGKBlockFromButton, {
      interval: 200,
      timeout: 5000,
    });
  }, 50);
});

function addASGKBlockFromButton(): void {
  setTimeout(() => {
    const form: HTMLFormElement | null = document.querySelector('[data-formsended-callback]');
    const asgk: Element | null = document.querySelector('#asgk');
    if (form && !added) {
      if (asgk) {
        asgk.remove();
      }

      addASGKBlock(form);
    }
  }, 250);
}

function addASGKBlock(form: HTMLFormElement): void {
  const newDiv: HTMLDivElement = document.createElement("div");
  newDiv.id = "asgk";
  newDiv.style.margin = "40px 0px";

  const errorbox: Element | null = form.querySelector('.t-form__errorbox-middle');
  const fallback: Element | null = form.querySelector('.t-form__inputsbox.t-form__inputsbox_inrow');

  // добавить newDiv в тот блок, который нашелся
  (errorbox || fallback)?.append(newDiv);

  added = true;

  ReactDOM.render(<DiscountPage form={form}/>, newDiv);
}
